import { render, staticRenderFns } from "./ProductGroupsPage.vue?vue&type=template&id=30c999d9&"
import script from "./ProductGroupsPage.vue?vue&type=script&lang=js&"
export * from "./ProductGroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports